import { render } from "./main-layout.vue?vue&type=template&id=73f2d153&ts=true"
import script from "./main-layout.vue?vue&type=script&lang=ts"
export * from "./main-layout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__